import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { Box, Button, Chip, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import PageBanner from '../../components/Common/PageBanner';
import { blogDetailFallback, blogPosts, pageActions, pageContent } from '../../data/siteData';

function BlogDetailPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const content = pageContent.blogDetailPage;
  const post = blogPosts.find((item) => item.slug === slug);
  const relatedPosts = blogPosts.filter((item) => item.slug !== slug).slice(0, 3);

  if (!post) {
    return (
      <Box>
        <PageBanner
          title={blogDetailFallback.title}
          subtitle={blogDetailFallback.subtitle}
          breadcrumb={[
            { label: 'Home', path: '/' },
            { label: 'Blog', path: '/blog' },
            { label: blogDetailFallback.title, path: '/blog' },
          ]}
        />
        <Container maxWidth="md" sx={{ py: 10 }}>
          <Button startIcon={<ArrowBackRoundedIcon />} onClick={() => navigate('/blog')}>
            {content.backLabel}
          </Button>
        </Container>
      </Box>
    );
  }

  return (
    <Box>
      <PageBanner
        title={post.title}
        subtitle={post.excerpt}
        breadcrumb={[
          { label: 'Home', path: '/' },
          { label: 'Blog', path: '/blog' },
          { label: post.title, path: `/blog/${post.slug}` },
        ]}
      />
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 10 } }}>
        <Grid container spacing={4}>
          <Grid item xs={12} lg={8}>
            <Button startIcon={<ArrowBackRoundedIcon />} onClick={() => navigate('/blog')} sx={{ mb: 3 }}>
              {content.backLabel}
            </Button>
            <Chip label={post.category} sx={{ bgcolor: '#fff6de', color: '#c9a84c', mb: 2 }} />
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 3, color: 'text.secondary' }}>
              <Typography>{post.date}</Typography>
              <Typography>{post.author}</Typography>
            </Stack>
            <Stack spacing={2.4}>
              {post.content.map((paragraph) => (
                <Typography key={paragraph} sx={{ color: 'text.secondary', lineHeight: 1.9 }}>
                  {paragraph}
                </Typography>
              ))}
            </Stack>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Stack spacing={3}>
              <Paper elevation={0} sx={{ p: 3 }}>
                <Typography variant="h4" sx={{ mb: 2 }}>{content.relatedHeading}</Typography>
                <Stack spacing={2}>
                  {relatedPosts.map((item) => (
                    <Paper key={item.slug} elevation={0} sx={{ p: 2, bgcolor: '#fffdfa', border: '1px solid rgba(74,14,143,0.08)' }}>
                      <Typography component={RouterLink} to={`/blog/${item.slug}`} variant="h5" sx={{ display: 'block', mb: 0.8 }}>
                        {item.title}
                      </Typography>
                      <Typography sx={{ color: 'text.secondary', fontSize: '0.92rem' }}>{item.date}</Typography>
                    </Paper>
                  ))}
                </Stack>
              </Paper>
              <Paper elevation={0} sx={{ p: 3, bgcolor: '#1a0533', color: '#ffffff' }}>
                <Typography variant="h4" sx={{ color: '#ffffff', mb: 1.2 }}>{content.contactBoxTitle}</Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.72)', lineHeight: 1.75, mb: 2 }}>
                  {content.contactBoxDescription}
                </Typography>
                <Button component={RouterLink} to={pageActions.contactPath} variant="contained" color="primary">
                  {content.contactBoxButton}
                </Button>
              </Paper>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default BlogDetailPage;
